import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersRoleplayingConditionMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  body: {
    title: string;
    content: RawDraftContentState;
    postDate: string;
    participationEmployeeIds: string[];
    providingServiceId?: string;
    skillEvaluationStandardSummaryCategoryId?: string;
    roleplayingConditionTemplateId?: string;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersRoleplayingConditionMutateType>(
      "/api/members/roleplaying_conditions",
      {
        roleplayingCondition: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersRoleplayingConditionsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersRoleplayingConditionMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
